var React = require('react');

function CircleHalfInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"6.5","cy":"6.5","r":"5.5","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M6.5 6.5L12.1875 6.5C12.1875 2.75 8.6875 1.625 6.5 1.625L6.5 6.5Z","key":1}),React.createElement("path",{"d":"M6.5 6.5L12.1504 6.5C12.5851 9.98214 9.10805 11.375 6.5 11.375L6.5 6.5Z","key":2})]);
}

CircleHalfInline.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = CircleHalfInline;

CircleHalfInline.default = CircleHalfInline;
